module.exports = __webpack_public_path__ + "media/images/headertop-88ad78686a9bca5693b829fe4913370c.png";